export default "__VITE_ASSET__BkAj2I_g__"